<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :count='count' :current='page'
      :disablePage='disablePage'>
      <div slot="queryParams" class="form">


        <div class="queryContainer">
          <div class="queryItem">
            <label>供应商名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.supplierName'></lk-input>
          </div>
          <div class="queryItem">
            <label>验收时段:</label>
            <timeStampDatePicker type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.inspectionTime'
              ></timeStampDatePicker>
          </div>

          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>

            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>


          </div>
          <!-- <div class="queryItem">
            <label>创建人:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.createUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select class="item" clearable v-model.trim='query.supplierId'>
              <lk-option v-for="(item,index) in suppliers" :key="index" :value='item.id'>
                {{item.name}}</lk-option>
            </lk-select>
          </div> -->

          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">

          <DownloadButton @on-click="handleExport" v-if="handlePermission('outputFinanceSupplierList')" ></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'payment',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
  },

  computed: {
    roleType() {
      return this.$store.state.user.roleType;
    },
    permission() {
      return this.$store.state.app.permissionList;
    },
  },
  data() {
    return {
      storeList: [],
      disablePage: false,

      suppliers: [],


      query: {
        supplierName: '',
        inspectionTime: [],

      },
      params: {
        supplierName: '',
        inspectionTime: [],

      },


      columns: [

        { title: '序号', key: 'index', minWidth: 116 },
        { title: '供应商编码', key: 'supplierCode', minWidth: 116 },
        {
          title: '供应商名称',
          key: 'supplierName',
          minWidth: 116,
          render: (h, params) => h('span', {
            props: {
              // type: 'text',
              // size: 'small',
            },
            class: {
              blue: true,

            },
            on: {
              click: () => {
                console.log(this);

                if (this.permission.includes('supplierStoreCheck')) {
                  this.$router.push({ name: 'supplierStoreCheck', params: { id: params.row.supplierId } });
                } else {
                  this.$Message.error('您没有权限查看供应商');
                }
                // this.$router.push({ name: 'proceedEdit', params: { storeName: 'testname', id: params.row.id } });
              },
            },
          }, params.row.supplierName),
        },
        // { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        { title: '采购验收金额', key: 'inspectionAmount', minWidth: 116 },
        { title: '退货金额', key: 'refundAmount', minWidth: 116 },
        { title: '已付金额', key: 'paymentAmount', minWidth: 116 },
        { title: '应付金额', key: 'payableAmount', minWidth: 116 },
        { title: '剩余可用预付', key: 'availablePrepaymentAmount', minWidth: 116 },

      ],
      tableData: [


      ],
      // localtion: [],
      // levels: ['一级', '二级', '三级'],
    };
  },
  methods: {
    handleExport() {
      const params = utils.deepClone(this.params);
      if (params.inspectionTime.length) {
        params.inspectionTimeStart = params.inspectionTime[0] - 8 * 3600000;
        params.inspectionTimeEnd = params.inspectionTime[1] + 16 * 3600000 - 1;
        delete params.inspectionTime;
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      delete params.page;
      delete params.size;
      finance.outputFinanceSupplierStatsList(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // output() {
    //   const params = utils.deepClone(this.query);
    //   if (params.inspectionTime.length) {
    //     params.inspectionTimeStart = params.inspectionTime[0] - 8 * 3600000;
    //     params.inspectionTimeEnd = params.inspectionTime[1] + 16 * 3600000 - 1;
    //     delete params.inspectionTime;
    //   }
    //   finance.outputFinanceSupplierStatsList(params).then((res) => {
    //     utils.downLoadExcel(res);
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },
    clear() {
      this.query = {
        supplierName: '',
        inspectionTime: [],
        storeIdList: [],
      };
    },
    getlocaltions() {

    },
    loadLocaltion() {

    },

    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      if (this.params.inspectionTime.length) {
        this.params.inspectionTimeStart = this.params.inspectionTime[0] - 8 * 3600000;
        this.params.inspectionTimeEnd = this.params.inspectionTime[1] + 16 * 3600000 - 1;
      }
      const temp = utils.deepClone(this.params);
      delete temp.inspectionTime;
      finance.getFinanceSupplierStatsList(temp).then((res) => {
        if (res.data.status === 200) {
          // console.log(res.data.data);
          this.tableData = [];
          // console.log(res.data.data.count);
          this.count = res.data.data.count;
          res.data.data.list.forEach((item, i) => {
            item.index = (this.page - 1) * this.size + i + 1;
            // const result = {};
            item.createTime = utils.exchangeTime(item.createTime);

            this.tableData.push(item);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

  },
  mounted() {
    if (this.roleType !== 2) {
      // this.getStoreList();
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    if (!this.handlePermission('printFinanceSupplierList')) {
      this.columns.slice(0, this.columns.length - 1);
    }
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  // .form{
  //   margin-top: 16px
  // }

  .btns{
    margin-bottom: 12px;
    >*{
      margin-right: 16px
      }
    }

  .queryContainer{//样式写进公共类中
    display: flex;
    padding-bottom: 16px;
      flex-wrap: wrap;

    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
</style>
